import BasicRouterView from "../../components/BasicRouterView.vue";

const orgRoutes = {
  path: "org",
  redirect: { name: "org-area" },
  meta: {
    label: "Organizacional",
    icon: "domain",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "organizacional/area",
      name: "org-area",
      meta: {
        label: "Cadastrar Área",
        icon: "business",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pdt" */ "./area/views/Cadastrar.vue"),
    },
    {
      path: "organizacional/fornecedor",
      name: "org-fornecedor",
      meta: {
        label: "Cadastrar Fornecedor",
        icon: "person_add",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./area/views/CadastrarFornecedores.vue"
        ),
    },
    {
      path: "organizacional/editar-fornecedor/:id",
      name: "editarFornecedor",
      meta: {
        label: "Editar Fornecedor",
        icon: "edit",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pdt" */ "./area/views/EditarFornecedor.vue"
        ),
    },
  ],
};

export default orgRoutes;
